import {
  ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES,
  getInsuranceTypeLabelProperty,
  getInsuredValueLabelProperty,
  labelConfigSelector,
  updateLabelConfig,
} from '../../../data/labelInfos/index.js'
import ConfigSelect from './ConfigSelect.js'
import {SHIPPO} from '../../../common/constants/ShipperNames.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import {defaultValidLabelPropertiesFunc} from './useLabelProperty.js'
import {getState, useSelector} from '../../../store.js'
import {useEffect} from 'react'

const VALID_SHIPPER_TYPES = [SHIPPO]

const INSURANCE_TYPE_DEPENDENT_PROPERTIES = [
  ...ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES,
  ...VALID_SHIPPER_TYPES.map((shipperType) =>
    getInsuredValueLabelProperty(shipperType),
  ),
]

function dependentPropertiesFunc() {
  return INSURANCE_TYPE_DEPENDENT_PROPERTIES
}

function labelPropertiesFunc(shipperType, labelInfoID) {
  let {[getInsuredValueLabelProperty(shipperType)]: insuredValue} =
    labelConfigSelector(getState(), {
      labelInfoID,
    })

  insuredValue = Number(insuredValue) || 0

  return insuredValue > 0 && VALID_SHIPPER_TYPES.includes(shipperType)
    ? [getInsuranceTypeLabelProperty(shipperType)]
    : []
}

export default function InsuranceType() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const propertySpecs = InsuranceType.propertySpecList[0]
  const labelProperty = getInsuranceTypeLabelProperty(shipperType)
  let {
    [getInsuredValueLabelProperty(shipperType)]: insuredValue,
    [labelProperty]: insuranceType,
  } = useSelector((state) =>
    labelConfigSelector(state, {
      labelInfoID,
    }),
  )

  insuredValue = Number(insuredValue) || 0
  const hide = insuredValue <= 0

  useEffect(() => {
    updateLabelConfig(labelInfoID, {
      [labelProperty]: hide ? null : insuranceType || shipperType,
    })
  }, [hide])

  return (
    <ConfigSelect
      label="Insurance Type"
      value={insuranceType}
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {
          [labelProperty]: value,
        })

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      shipperOptionsProperty="insurance"
      hide={hide}
      noEmptyOption
    />
  )
}

InsuranceType.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc,
    dependentPropertiesFunc,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]

export function InsuranceTypeNotice() {
  const {labelInfoID, shipperType, isSummary, isPickMode} =
    useLabelConfigContext()
  const [insuranceTypePropertySpecs] = InsuranceType.propertySpecList
  const [insuranceTypeLabelProperty] =
    insuranceTypePropertySpecs.labelPropertiesFunc(shipperType, labelInfoID)

  let {[insuranceTypeLabelProperty]: insuranceType} = useSelector((state) =>
    labelConfigSelector(state, {
      labelInfoID,
    }),
  )

  const needsNotice = insuranceType === SHIPPO

  if (!needsNotice || isSummary || isPickMode) {
    return null
  }

  return (
    <li className="list__item--shipping-options fs-n1 lh-md wrap--edit-preset-modal-hide-item margin-bottom-10">
      By adding protection, you agree to the{' '}
      <a
        className="btn btn--link darker border-underline v-align-base"
        href="https://www.xcover.com/en-us/pds/shipping-protection-shippo-us"
        target="_blank"
        rel="noopener noreferrer"
      >
        terms, conditions, and exclusions
      </a>
      . Protection sold by Cover Genius and powered by XCover.
    </li>
  )
}
